import ContainerBase from 'lib/ContainerBase';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import globalSettingsSelector from 'state/selectors/globalSettings';
import { fetchPhoneFlowProducts } from 'state/actions/shopifyCatalogueActions';
import { AppState, Dispatch } from 'state/types';
import { PhoneFlowProducts } from 'state/reducers/shopifyCatalogue';
import lightFlipConfig from 'config/phoneModels/lightFlip';

class LightFlipFlowContainer extends ContainerBase {
  // @ts-ignore
  view = import('views/PhoneFlow');

  model = async () => {
    const existingProducts =
      this.props.lightPhoneFlowProducts; 

    if (existingProducts) {
      return {
        config: lightFlipConfig,
        phoneFlowProducts: existingProducts
      };
    }

    let phoneFlowProducts: PhoneFlowProducts | null = null;

    try {
      phoneFlowProducts = await this.props.actions
        .fetchPhoneFlowProducts()
        .then(({ value }) => value);

      return { config: lightFlipConfig, phoneFlowProducts };
    } catch (error) {
      console.log(error);
    }

    return {
      config: lightFlipConfig,
      phoneFlowProducts
    };
  };
}

const mapStateToProps = (state: AppState) => ({
  lightPhoneFlowProducts: state.shopifyCatalogue.phoneFlowProducts,
  globalSiteSettings: globalSettingsSelector(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ fetchPhoneFlowProducts }, dispatch)
});

const connector = connect(mapStateToProps, mapDispatchToProps);

// @ts-ignore
export default connector(LightFlipFlowContainer);
